import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Toolbar, Typography } from "@mui/material";
import * as React from "react";
import { FormProvider, useForm } from "react-hook-form";
import ReusableCard from "../../components/card/ReusableCard";
import GuestContactInformation from "../../components/guest-order/ContactInformation";
import GuestShippingInformation from "../../components/guest-order/ShippingInformation";
import GuestOthersInformation from "../../components/guest-order/OtherInformation";
import "./GuestUser.scss";
import UploadFile from "../../components/guest-order/UploadFile";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ADL_Sidebar_Logo from "../../assets/images/ADL_Logo_White.webp";
import { GuestOrderFormData, GuestOrderPayload } from "../../types/guestOrder";
import useGuestOrderService from "../../services/guestOrder/service";
import GuestAccountInformation from "../../components/guest-order/AccountInformation";
import GuestOrderSuccess from "../guest-order-success/GuestOrderSuccess";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/root/config.store";
import LoginIcon from '@mui/icons-material/Login';
import SnackbarNotifier from "../../components/snackbar/Snackbar";
import { guestOrderActions } from "../../store/guestOrder/slice";
import { clearAllFiles } from "../../store/guestOrderUploadFile/slice";
import { REFERRAL_LIST, US_STATES } from "../../utils/common/constants";
import { showSnackbar } from "../../store/snackbar/slice";

export default function GuestUser(props: any) {
  const dispatch = useDispatch();
    const navigate = useNavigate();
   const [uploadKey, setUploadKey] = useState(0);
     const handleAddMore = () => {
    navigate("/label-catalog", {
      state: { returnToQuickOrder: true },
    });
  };
    const [showOrderSuccess, setShowOrderSuccess] = useState(false);
    const [openGuestLoginConfirmation, setOpenGuestLoginConfirmation] = useState(false);
    const { data, success, error } = useSelector(
        (state: RootState) => state.guestOrder
      );

  const { guestOrder, submitGuestOrder } =
      useGuestOrderService();
const storedDataInfo = localStorage.getItem("customerInfo");
  const customerInfoValues = storedDataInfo ? JSON.parse(storedDataInfo) : {};

   const methods = useForm<GuestOrderFormData>({
      mode: "onChange",
      reValidateMode: "onChange",
      defaultValues: {
        PONo: "",
        RONo: "",
        OrderAttachments: [],
        Instructions: "",
        IsOvernightDelivery: false,
      },
    });

  const handleLogin = () => {
      const redirectUrl = `${process.env.REACT_APP_LKQPORTAL_URL}`;
      window.location.replace(redirectUrl);
  }

  const handleStay = () => {
    setOpenGuestLoginConfirmation(false);
  }

  const openLoginModal = () => {
    setOpenGuestLoginConfirmation(true);
  }

  const onReset = () => {
    dispatch(guestOrderActions.resetGuestOrderState());
    dispatch(clearAllFiles());
    methods.reset({
      PONo: "",
      RONo: "",
      OrderAttachments: [],
      Instructions: "",
      ShopName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      AccountNumber: "",
      Phone: "",
      AddressLine1: "",
      AddressLine2: "",
      StreetAddress: "",
      City: "",
      ZipCode: "",
      ConfirmEmail: "",
      TotalQuantityOrder: 0,
      CountryName : "US",
      State: US_STATES[0],
      ReferralSourceOther: "",
      ReferralSourceId: 0
    });
      }

      const onSubmit = (data: GuestOrderFormData) => {
       
        if ((!data.OrderAttachments || data.OrderAttachments?.filter((file) => file?.isActive)?.length === 0)
        ) {
          dispatch(showSnackbar({
            message: "At least one attachment is required.",
            severity: "error",
          }))
          return false;
        }

      const updatedData : GuestOrderPayload= {
        UserName: "Automation",
        ADLOrderID: 0,
        TotalQty: data.TotalQuantityOrder,
        "CustomerInfo.FirstName": data.FirstName || "",
        "CustomerInfo.LastName": data.LastName || "",
        "CustomerInfo.Email": data.Email || "",
        "CustomerInfo.PhoneNumber": data.Phone || "",
        "CustomerInfo.AccountNumber": data.AccountNumber || "0",
        "CustomerInfo.ShopName": data.ShopName || "",
        "ShippingInfo.ShippingInfoID": 0,
        "ShippingInfo.StreetAddress": "",
        "ShippingInfo.StateID": Number(data.State.id || 0),
        "ShippingInfo.CountryID": Number(data.State.countryID || 0),
        "ShippingInfo.CustomerInfoID": 0,
        "ShippingInfo.AddressLine1": data.AddressLine1 || "",
        "ShippingInfo.AddressLine2": data.AddressLine2 || "",
        "ShippingInfo.City": data.City || "",
        "ShippingInfo.StateName": data.State.label || "",
        "ShippingInfo.CountryName": data.State.countryID == 1 ? "United States" : "canada",
        "ShippingInfo.ZipCode": data.ZipCode || "",
        SourceEmail: data.Email || "", 
        SourceID: 17,
        ShipViaPost: data?.ShipViaPost || false,
        StatusID: 26,
        OrderAttachments: data.OrderAttachments,
        RONo: data.RONo,
        PONo: data.PONo,
        Instructions: data.Instructions,
        "CustomerInfo.CustomerInfoId": 0,
        IsOvernightDelivery: false,
        ReferralSourceID: data?.ReferralSource?.id,
        RefSourceOthers: data?.Other || "",
      };
      
         submitGuestOrder({ ...updatedData });
      };
      useEffect(() => {
          if (success && !error && data?.adlOrderNo) {
              setShowOrderSuccess(true);
          }
        },[success, error, data]);

      if (showOrderSuccess && data?.adlOrderNo) {
          const orderId = data?.adlOrderNo;
          const orderDateRaw = data?.emailReceivedDate || new Date().toISOString();
          const date = new Date(orderDateRaw).toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
          });
      
          return (
            <GuestOrderSuccess
              orderId={orderId}
              orderDate={date}
              onContinue={() => {
                onReset();
                setShowOrderSuccess(false);
              }}
            />
          );
        }

  return (
   <FormProvider {...methods}>
         <form onSubmit={methods.handleSubmit(onSubmit)}>
          <SnackbarNotifier />
          <Box
        className="drawer-logo" width={"100%"}
        sx={{
          display: "flex",
          alignItems: "left",
          justifyContent: "normal",
          backgroundColor: " #014C8A",
          padding: "35px 20px",
          marginBottom: "15px",
          color: "white"
        }}
      >
       <Typography style={{width:"35%"}}>
        <img
          className={"sidebar-logo"}
          src={ADL_Sidebar_Logo}
          style={{
            transition: "width 0.15s",
            height: 55,
            width: "auto",
            objectFit: "contain",
            display: "block"
          }}
          alt="ADL Logo"
        />
        </Typography>
        <Typography variant="h4" style={{fontWeight:"500", width:"60%"}}>Order Replacement Labels</Typography>
        <Typography  style={{fontWeight:"500", width:"5%", textAlign:"right"}}><LoginIcon onClick={openLoginModal} style={{cursor:"pointer"}}/></Typography>
        
      </Box>
     
           <Box className="guest-order-wrapper">
            <Box className = "info">
              <ReusableCard title="Account Information">
               <GuestAccountInformation />
             </ReusableCard>
            </Box>
            <Box className = "info">
             <ReusableCard title="Contact Information">
               <GuestContactInformation />
             </ReusableCard>
             </Box >
              <Box className = "info"><ReusableCard title="Shipping Information">
               <GuestShippingInformation />
             </ReusableCard></Box>
          <Box className = "info">
            <UploadFile key={uploadKey} onAddMore={handleAddMore} />
          </Box>
          {/*
          <Box >
          <ReusableCard >
               <GuestOthersInformation />
             </ReusableCard>
              </Box>*/}
             <ReusableCard
               contentSx={{ display: "flex", justifyContent: "center" }}
             >
              <Button
                    variant="contained"
                    className="search-button" style={{marginRight:"10px"}}
                    onClick={onReset}
                  >
                   Reset
                 </Button>
                
                 <Button
                    type="submit"
                    variant="contained"
                    className="search-button"
                  >
                   Submit
                 </Button>
                
             </ReusableCard>
           </Box>
           <Dialog
                     open={openGuestLoginConfirmation}
                     onClose={() => {
                       setOpenGuestLoginConfirmation(false);
                     }}
                     aria-labelledby="alert-dialog-title"
                     aria-describedby="alert-dialog-description"
                     className="guest-order-login-confirm"
                   >
                     <DialogTitle id="alert-dialog-title">
                       Confirm Navigation
                     </DialogTitle>
                     <DialogContent>
                       <DialogContentText id="alert-dialog-description">
                         Are you sure you want to go to the login page? Your progress will be lost.
                       </DialogContentText>
                     </DialogContent>
                     <DialogActions>
                       <Button type="button" onClick={handleStay} variant="outlined">
                         Stay
                       </Button>
                       <Button type="button" onClick={handleLogin} variant="contained">
                         Go to Login
                       </Button>
                     </DialogActions>
                   </Dialog>
         </form>
   
       </FormProvider>
  );
}
